import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { NavbarComponent } from 'src/app/components/navbar/navbar.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { CommonModule } from '@angular/common';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { WelcomeSlideComponent } from './welcome-slide/welcome-slide.component';
import { INRCurrencyPipe } from '../pipes/inrcurrency.pipe';
import { SelectedPlanComponent } from './selected-plan/selected-plan.component';
import { EcsCheckoutComponent } from './ecs-checkout/ecs-checkout.component';
import { MenuModalComponent } from './menu-modal/menu-modal.component';
import { HealthClaimSettlementComponent } from './health-claim-settlement/health-claim-settlement.component';
import { ProposalComponent } from './proposal/proposal.component';
import { VehicleSettlementComponentComponent } from './vehicle-settlement-component/vehicle-settlement-component.component';
import { CareKycComponent } from './care-kyc/care-kyc.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AutocompleteLibModule,
  ],
  declarations: [
    NavbarComponent,
    WelcomeSlideComponent,
    INRCurrencyPipe,
    SelectedPlanComponent,
    ProposalComponent,
    EcsCheckoutComponent,
    MenuModalComponent,
    HealthClaimSettlementComponent,
    VehicleSettlementComponentComponent,
    CareKycComponent
  ],
  exports: [
    NavbarComponent,
    WelcomeSlideComponent,
    
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    INRCurrencyPipe,
    SelectedPlanComponent,
    ProposalComponent,
    EcsCheckoutComponent,
    MenuModalComponent,
    HealthClaimSettlementComponent,
    AutocompleteLibModule,
    CareKycComponent
  ]
})
export class SharedComponentsModule {}